
<div class="row">
    <div class="col-md-5">
        <span class="section-title  margin-top-20">Projected Financial Insights as of {{fiscalYear?.fiscalYearStartMonth + '/1/' + fiscalYear?.year}} </span>
        <div class="section-container section-height">
            <div class="key-insights">
                    <div class="margin-top-20"><strong>{{reportData?.reserveAccountBalance | currency:'USD':'symbol-narrow':'1.0-0' }}</strong><span>Starting Reserve Account Balance</span></div>
                    <div><strong>{{getContributionsToReserves() | currency:'USD':'symbol-narrow':'1.0-0'}}
                        <div class="popover-info" 
                             (mouseenter)="showContributionsPopover($event)"
                             (mouseleave)="hideContributionsPopover()">
                            <i class="fa fa-question-circle"></i>
                        </div></strong>
                        <span>Contributions to Reserves</span>
                    </div>
                    <div><strong>{{reportData?.componentInventoryReport?.currentReplacementCost | currency:'USD':'symbol-narrow':'1.0-0' }}</strong><span>Current Replacement Cost</span></div>
                    <div><strong>{{reportData?.percentageFunded | number:'1.0-0' }}%</strong><span>Initial Percent Funded</span></div>
                    <div class="text-end"><a class="btn btn-link" [routerLink]="['/useraccount/plans/assumptions']">View Financial Assumptions</a></div>
            </div>
        </div>
    </div>
    <div class="col-md-7">
        <span class="section-title margin-top-20">What's on the calendar for {{fiscalYear?.yearRange}} </span>
        <div class="row section-container section-height">
            <div class="col-md-12 anticipated-expenditures">
                <p>The list below is a roadmap for projects that are scheduled to be replaced, repaired or maintained in the {{fiscalYear?.yearRange}} budget year.</p>
                <table class="table table-sm">
                    <thead class="thead-light">
                    <tr>
                        <th scope="col">Top Anticipated Expenditures</th>
                        <th scope="col" class="text-end">Replacement Costs</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let propertyComponent of reportData?.topExpenditures">
                        <td><a class="btn btn-link padding-left-0 component-name" [routerLink]="['/useraccount/components', propertyComponent.propertyComponentId]" (click)="setBackTo()">{{propertyComponent.name}}</a></td>
                        <td class="text-end">{{propertyComponent.currentReplacementCost | currency:'USD':'symbol-narrow':'1.0-0' }}</td>
                    </tr>
                    </tbody>
                    <tfoot>
                    <tr>
                        <td colspan="2"><a class="btn btn-link padding-right-0" [routerLink]="['/useraccount/reports/anticipated-expenditures']">View Anticipated Expenditures Report</a></td>
                    </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</div>

<span class="section-title margin-top-20">Compare Funding Plans</span>
<div class="row section-container plan-comparison">
    <div class="col-md-12">
        <div class="text-muted font-light"><span class="fa fa-star margin-right-5"></span>Recommended funding plan</div>
        <table class="report-data report-table-remove-margin">
            <tr class="report-grid-header multiline">
                <th class=""><span>Funding Plans</span></th>
                <th class="u-textRight"><span>Annual Reserve<br />Contributions</span></th>
                <th class="u-textRight"><span>{{collectionFrequency}} Reserve Contributions<br />(Avg. Per {{ 'Unit' | terminology | async }})</span></th>
                <th class="u-textRight"><span>Will Meet All<br />Anticipated Expenditure<br />During Next {{ reportData?.fundingReport?.duration }} Years</span></th>
                <th class="u-textRight"><span>1st Year of<br />Reserve Deficit<br />(if Applicable)</span></th>
            </tr>
            <ng-container *ngFor="let plan of plans">
                <ng-container>
                    <tr class="report-grid-row" class="report-grid-row" [class.adopted]="plan.isAdopted || disclosurePlanId == plan.planId">
                        <td class="u-textNoWrap">
                            <div *ngIf="plan.isAdopted || disclosurePlanId == plan.planId"><span class="badge badge-gray-dark">Adopted funding plan</span></div>
                            <a class="btn btn-link" routerLink="/useraccount/plans/{{plan.planId}}">{{plan?.name}}
                                <i *ngIf="plan?.fundingReport?.isRecommendedPlan && !plan?.fundingReport?.isDefaultRecommendedPlan" class="fa fa-star" title="recommended plan"></i>
                            </a>
                        </td>
                        <td class="u-textRight"><span>{{plan?.fundingReport?.years[0]?.annualReserveContributions | currency:'USD':'symbol-narrow':'1.0-0'}}</span></td>
                        <td class="u-textRight"><span>{{plan?.fundingReport?.years[0]?.reserveContributionsPerUnitFrequency | currency:'USD':'symbol-narrow':'1.2-2'}}</span></td>
                        <td class="u-textRight">
                            <span class="solvent-yes" *ngIf="plan.fundingReport?.willMeetAllDisbursementRequirements"><i class="fa fa-check margin-right-5" aria-hidden="true"></i> Yes</span>
                            <span class="solvent-no" *ngIf="!plan.fundingReport?.willMeetAllDisbursementRequirements"><i class="fa fa-times margin-right-5" aria-hidden="true"></i> No</span>
                        </td>
                        <td class="u-textRight">
                            <span class="text-muted font-light" *ngIf="plan.fundingReport?.willMeetAllDisbursementRequirements">N/A</span>
                            <span class="solvent-no" *ngIf="!plan.fundingReport?.willMeetAllDisbursementRequirements">{{plan?.fundingReport?.firstYearOfReserveDeficit}}</span>
                        </td>
                    </tr>
                </ng-container>
            </ng-container>
        </table>

        <div class="text-end margin-top-20">
            <a class="btn btn-link" [routerLink]="['/useraccount/plans']">View Funding Plans</a>
        </div>
    </div>
</div>


<ng-container *ngIf="futurePlan != null">
    <span class="section-title margin-top-20">What does the future look like?</span>
    <div class="row section-container padding-bottom-0">
        <div class="col-md-12 future">
            <div class="row text">
                <div class="col-md-12">
                    <div class="future-message">
                        <i class="fa fa-exclamation-triangle"></i>
                        Future information is based on the {{hasAdoptedPlan ? 'adopted': 'recommended'}} funding plan for {{fiscalYear?.yearRange}}: <strong>{{futurePlan?.name}}</strong>
                    </div>
                    {{futurePlan?.fundingReport?.header.reportSummary}}
                </div>
            </div>

            <div class="row margin-top-20">
                <div class="col-md-3">
                    <select class="sp-select form-control" #years (change)="displayYearsDropdownChanged()">
                        <option value="5">Display 5 years</option>
                        <option value="10">Display 10 years</option>
                        <option value="15">Display 15 years</option>
                        <option value="20">Display 20 years</option>
                        <option value="25">Display 25 years</option>
                        <option value="30" selected>Display 30 years</option>
                    </select>
                </div>
                <div class="col-md-9 text-end">
                    <i class="fa fa-info-circle"></i>
                    <i>View individual expenditures per year by clicking on the blue vertical bars</i>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 report-chart">
                    <!-- <sp-funding-report-chart
                        [fundingReport]="futurePlan?.fundingReport"
                        [numberOfYears]="years.value"
                        (yearSelected)="selectExpenditureYear($event)">
                    </sp-funding-report-chart> -->

                    <sp-devex-funding-report-chart 
                        [fundingReport]="futurePlan?.fundingReport" 
                        [numberOfYears]="years.value"
                        (yearSelected)="selectExpenditureYear($event)">
                    </sp-devex-funding-report-chart>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 text-end margin-bottom-20">
                    <a class="btn btn-link padding-right-0" [routerLink]="['/useraccount/reports/plan', futurePlan?.planId]">View Your Funding Plan</a>
                </div>
            </div>

            <div id="anticipated-expenditures" class="scroll-margin">
                <ng-container *ngIf="selectedExpenditureYear">
                    <div class="row report-grid-header multiline">
                        <div class="col-md-3 text-start"><span>Name</span></div>
                        <div class="col-md-3 text-start"><span>Category</span></div>
                        <div class="col-md-3 text-end"><span>Current Replacement Cost</span></div>
                        <div class="col-md-3 text-end"><span>Anticipated Expenditures</span></div>
                    </div>

                    <div class="row report-section-header">
                        <div class="col-md-6">
                            {{ selectedExpenditureYear }}
                        </div>
                        <div class="col-md-6 text-end">
                            <button class="btn btn-icon" (click)="selectedExpenditureYear = null" popover="Clear selected year" triggers="mouseenter:mouseleave" placement="bottom"><i class="fa fa-times fa-2x" aria-hidden="true"></i></button>
                        </div>
                    </div>

                    <div class="row report-grid-row" *ngFor="let item of selectedAnticipatedExpenditures">
                        <div class="col-md-3 text-start" [title]="item.name">
                            <a routerLink="/useraccount/components/{{item.propertyComponentId}}" (click)="setBackTo()" [innerHTML]="item.name | truncate : 50"></a>
                        </div>
                        <div class="col-md-3 text-start"><span>{{ item.propertyComponentCategoryName}}</span></div>
                        <div class="col-md-3 text-end"><span>{{ item.currentReplacementCost | currency:'USD':'symbol-narrow':'1.0-0'}}</span></div>
                        <div class="col-md-3 text-end"><span>{{ item.anticipatedExpenditures | currency:'USD':'symbol-narrow':'1.0-0'}}</span></div>
                    </div>

                    <div class="row report-grid-row-total">
                        <div class="col-md-6 text-end"><span><strong>Total:</strong></span></div>
                        <div class="col-md-3 text-end"><span><strong>{{ totalCurrentReplacementCost | currency:'USD':'symbol-narrow':'1.0-0'}}</strong></span></div>
                        <div class="col-md-3 text-end"><span><strong>{{ totalAnticipatedExpenditures | currency:'USD':'symbol-narrow':'1.0-0'}}</strong></span></div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</ng-container>

<dx-popover 
    #contributionsPopover
    [(target)]="contributionsPopoverTarget" 
    position="right"
    [width]="400"
    (onHiding)="onContributionsPopoverHiding($event)"
    (onContentReady)="onContributionsPopoverContentReady($event)">
    <div *dxTemplate="let data = model; of: 'content'">
        <div class="popover-container">
            <div>Contributions to Reserves for {{fiscalYear?.yearRange}} is based off of the <a [routerLink]="['/useraccount/reports/plan', futurePlan ? futurePlan.planId : reportData?.fundingReport?.planId]">{{futurePlan ? futurePlan.name : reportData?.fundingReport?.name}}</a> funding plan.</div>
        </div>
    </div>
</dx-popover>
